/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import { getAllCategories } from "../../../../redux/features/sharedResources/sharedResources.js";
import {
  GlobalConfiguration,
  PaginationConfiguration,
  ScreenSizeConfiguration,
} from "../../../../utils/configurationProvider.js";
import CategoriesEdit from "../../../_utils/AccountCreationComponents/CategoriesEdit/index.jsx";
import PrimaryButton from "../../../_utils/CommonButtons/PrimaryButton/index.jsx";
import PrimaryStepper from "../../../_utils/CommonSteppers/PrimaryStepper/index.jsx";
import CommonToast from "../../../_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../_utils/CommonTopNav/TopNavComponent/index.jsx";
import CardContainer from "../../../_utils/CommonViewAllCard/CardContainer/index.jsx";
import TextWithIcon from "../../../_utils/CommonViewAllCard/CardSubComponent/TextWithIcon/index.jsx";
import { formatAccountNumber } from "../../../_utils/FormatAccountNumber";
import IfscCodeMapper from "../../../_utils/IfscLogoMapper/index.js";
import PaginationComponent from "../../../_utils/PaginationComponent/index.jsx";
import TickerAnimation from "../../../_utils/TickerAnimation/index.jsx";
import UniversalRefreshToast from "../../../_utils/UniversalRefreshToast/index.jsx";
import Loader from "../../../Loader/Index";
import "./index.css";
import {
  editReimbursementAccount,
  ReimburseViewAll,
  viewAccountDetailR,
} from "../../../../redux/features/accounts/ReimburseAccount/index.js";

const ReimbursementUnassignCategories = (typepop) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const searchActionBtnRef = useRef(null);

  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const [currentStatus, setCurrentStatus] = useState("");
  const [currentPage, setCurrentPage] = useState(
    GlobalConfiguration.lengthCheckOne,
  );
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [active, setActive] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [showCatePopup, setShowCatePopup] = useState(false);
  const [defaultCategories, setDefaultCategories] = useState([]);
  const [categories, setCategories] = useState("");
  const [categoriesArray, setCategoriesArray] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [preSelectedCategories, setPreSelectedCategories] = useState([]);
  const [beneAccounts, setBeneAccounts] = useState([]);
  const [beneAccountsLoading, setBeneAccountsLoading] = useState(true);
  const [beneAccountSelected, setBeneAccountSelected] = useState([]);
  const [searchUserText, setSearchUserText] = useState("");
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");

  const [activeStep, setActiveStep] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const [checkmobile, setCheckmobile] = useState(false);
  const [pageSize, setPageSize] = useState(
    dropdownOptions[GlobalConfiguration.lengthCheckZero],
  );
  const [selectedValue, setSelectedValue] = useState(
    dropdownOptions[GlobalConfiguration.lengthCheckZero],
  );

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > ScreenSizeConfiguration.mobileScreen) {
        setActiveStep(GlobalConfiguration.lengthCheckZero);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

  const categoriesData = useSelector(
    (state) => state.sharedResources?.categoriesData?.categories,
  );

  useEffect(() => {
    setDefaultCategories(
      categoriesData.filter((category) => category?.active === "Y"),
    );
  }, [categoriesData]);

  const { ReimburseViewAllLoading, ReimburseViewAllData } = useSelector(
    (state) => state.ReimburseAccount,
  );

  const services = useSelector((state) => state.refreshToken.services);

  const beneEligibleAcct = (beneAccounts) => {
    if (
      Array.isArray(beneAccounts) &&
      beneAccounts?.length > GlobalConfiguration.lengthCheckZero
    ) {
      const beneAcctEligible = beneAccounts.find(
        (val) =>
          val?.approval_status !== "blocked" &&
          val?.approval_status !== "archived",
      );

      if (beneAcctEligible) {
        setBeneAccountSelected([beneAcctEligible?.id]);

        const selectedCategoriesArray = beneAcctEligible?.category
          .split(",")
          .filter((val) => val !== "");

        setSelectedCategories(selectedCategoriesArray);
      }
    }
  };

  const fetchAccountData = async (categories, currentPage, searchUserText) => {
    const queryParams = {
      page_no: currentPage,
      category: categories,
      search_string: searchUserText,
      page_size: pageSize,
      approval_status: ["pending", "approved", "rejected"],
      type: "homeDashboard",
    };
    if (currentStatus && currentStatus !== "all") {
      queryParams.approval_status = [currentStatus];
    }

    setBeneAccountsLoading(true);

    const response = await dispatch(ReimburseViewAll(queryParams));
    const newData = response?.payload?.reimbursement_accounts || [];

    if (response?.payload?.status === true) {
      setBeneAccounts(newData);
      beneEligibleAcct(newData);
    }

    setBeneAccountsLoading(false);
  };

  useEffect(() => {
    if (
      !defaultCategories ||
      defaultCategories.length === GlobalConfiguration.lengthCheckZero
    )
      return;

    if (ReimburseViewAllLoading) return;

    const categoryNames = defaultCategories.map((d) => d.name);
    const categoryNamesStr = categoryNames.join(",");

    setCategories(categoryNamesStr);
    setCategoriesArray(categoryNames);

    fetchAccountData(categoryNamesStr, currentPage, searchUserText);
  }, [defaultCategories, currentPage, currentStatus, searchUserText, pageSize]);

  useEffect(() => {
    beneEligibleAcct(beneAccounts);
  }, [beneAccounts]);

  useEffect(() => {
    if (
      Array.isArray(defaultCategories) &&
      selectedCategories.length > GlobalConfiguration.lengthCheckZero
    ) {
      const preSelectedCategories = defaultCategories.filter((category) =>
        selectedCategories.includes(category.name),
      );
      setPreSelectedCategories(preSelectedCategories);
    }
  }, [defaultCategories]);

  const nonPreSelectedCategories = defaultCategories.filter(
    (category) =>
      !preSelectedCategories.some(
        (selectedCat) => selectedCat.id === category.id,
      ),
  );

  const sortedCategories = [
    ...preSelectedCategories,
    ...nonPreSelectedCategories,
  ];

  const handleCategorySelect = (categoryId) => {
    const category = defaultCategories.find((cat) => cat.id === categoryId);
    if (!category) return;

    setSelectedCategories((prev) =>
      prev.includes(category.name)
        ? prev.filter((name) => name !== category.name)
        : [...prev, category.name],
    );
  };

  const handleClickAccountCard = async (id) => {
    setBeneAccountSelected([id]);

    const response = await dispatch(viewAccountDetailR({ id }));

    const account =
      response?.payload?.reimbursement_accounts?.[
        GlobalConfiguration.lengthCheckZero
      ];

    if (response?.payload?.status === true) {
      const selectedCategoriesArray = account?.category
        .split(",")
        .filter((val) => val !== "");
      setSelectedCategories(selectedCategoriesArray);
    }
  };

  const handleUpdateAccount = async (id) => {
    if (
      services?.includes("Admin") ||
      (services?.includes("RVAccount") &&
        services?.includes("PLogin") &&
        services?.includes("RUAccount"))
    ) {
      UniversalRefreshToast("unassignCate");
      if (beneAccountSelected?.length > GlobalConfiguration.lengthCheckZero) {
        const response = await dispatch(
          editReimbursementAccount({
            id: id,
            category: selectedCategories.toString(),
          }),
        );

        if (response?.payload?.status === true) {
          CommonToast({
            text: "Categories unassigned succesfully",
            icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
          setShowCatePopup(false);
          setActiveStep(GlobalConfiguration.lengthCheckZero);
          setCurrentPage(GlobalConfiguration.lengthCheckOne);
          fetchAccountData(categories, 1, searchUserText);
        }
      }
    } else {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "Admin, RVAccount, PLogin, RUAccount",
        },
      });
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "all":
        return "var(--text-primary)";
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "rejected":
      case "blocked":
        return "var(--failed)";
      case "archived":
        return "var(--abandoned)";
      default:
        return "var(--text-primary)";
    }
  };

  const dataArray = [
    {
      stepperText: "Select Account",
      nextText: "Next",
      previousText: "Back",
      previousDisableBgColor: "var(--primary-nav-act)",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextIsEnabled:
        !beneAccountsLoading &&
        Array.isArray(beneAccounts) &&
        beneAccounts.length > GlobalConfiguration.lengthCheckZero &&
        Array.isArray(beneAccountSelected) &&
        beneAccountSelected.length > GlobalConfiguration.lengthCheckZero,
      nextEnableBgColor: "var(--positive-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--text-primary)",
      nextDisableTextColor: "var(--text-secondary)",
    },
    {
      stepperText: "Select Category",
      nextText: "Update",
      previousText: "Back",
      previousDisableBgColor: "var(--primary-nav-act)",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextIsEnabled:
        Array.isArray(selectedCategories) &&
        selectedCategories.length > GlobalConfiguration.lengthCheckZero &&
        !(
          selectedCategories.includes("all") ||
          (categoriesArray?.length > GlobalConfiguration.lengthCheckZero &&
            categoriesArray.every((item) => selectedCategories.includes(item)))
        ) &&
        !beneAccountsLoading,
      nextEnableBgColor: "var(--positive-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextLoaderNeeded: true,
      nextIsLoading: beneAccountsLoading,
    },
  ];

  const handleForward = () => {
    if (activeStep === GlobalConfiguration.lengthCheckZero) {
      setShowCatePopup(true);
      handleClickAccountCard(
        beneAccountSelected?.[GlobalConfiguration.lengthCheckZero],
      );
      setActiveStep(GlobalConfiguration.lengthCheckOne);
    } else if (activeStep === GlobalConfiguration.lengthCheckOne) {
      handleUpdateAccount(
        beneAccountSelected?.[GlobalConfiguration.lengthCheckZero],
      );
    }
  };
  const handleBackward = () => {
    if (activeStep === GlobalConfiguration.lengthCheckOne) {
      setShowCatePopup(false);
      setActiveStep(GlobalConfiguration.lengthCheckZero);
    } else {
      navigate("/home");
    }
  };

  const handleSelect = (value) => {
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    setSelectedValue(value);
    setPageSize(value);
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    const handleResize = () => {
      setCheckmobile(window.innerWidth < ScreenSizeConfiguration.mobileScreen);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={`flex flex-col h-screen overflow-hidden`}>
      {!beneAccountsLoading &&
        beneAccounts?.length > GlobalConfiguration?.lengthCheckZero && (
          <div
            className={`${activeStep === GlobalConfiguration?.lengthCheckOne ? "Qsmd:block hidden" : "block"} ${showInnerSearchBar ? "opacity-lightest-opacity" : ""}
                fixed w-full bottom-bottom-base rounded-none h-pagination-height bg-primary-card z-z-index-dropdown `}
          >
            <PaginationComponent
              handleSelect={handleSelect}
              selectedValue={selectedValue}
              data={ReimburseViewAllData}
              pageSize={pageSize}
              dropdownOptions={dropdownOptions}
              handlePagination={handlePagination}
              currentPage={currentPage}
              setIsOpen={(e) => {}}
            />
          </div>
        )}

      {!beneAccountsLoading &&
        beneAccounts?.length > GlobalConfiguration?.lengthCheckZero && (
          <div
            className={`${showInnerSearchBar ? "opacity-lightest-opacity" : ""} ${activeStep === GlobalConfiguration?.lengthCheckOne ? "bottom-bottom-base" : "bottom-unassign-bottom-md"} Qsmd:hidden block fixed w-full bg-primary-card rounded-t-border-radius-md min-h-[calc(var(--day-date-card-height)+var(--dashed-line))] z-z-index-header`}
          >
            <PrimaryStepper
              activeStep={activeStep}
              handleForwardAction={handleForward}
              handleBackwardAction={handleBackward}
              dataArray={dataArray}
            />
          </div>
        )}

      <div
        className={`bg-primary-bg flex flex-col flex-1 h-screen overflow-hidden`}
        style={{
          position: "relative",
          overflowY: isSidebarOpen || showInnerSearchBar ? "hidden" : "",
          overflowX: "hidden",
          width: "var(--full-width)",
        }}
      >
        <div
          className={` relative z-z-index-overlay bg-primary-nav ${showInnerSearchBar && " fixed  w-full "}`}
        >
          <div className=" ">
            <div
              className={`hidden Qsmd:block h-navbar-breadcrumb-height   w-full `}
            ></div>
          </div>
        </div>

        <div
          className={`reimbursement_div_container Qmd:shadow-box-shadow-bottom Qmd:bg-primary-nav bg-primary-nav-act w-full-width relative `}
        >
          <TopNavComponent
            handleBack={() => {
              if (isSidebarOpen) {
                setIsSidebarOpen(false);
                return;
              }
              if (activeStep === GlobalConfiguration.lengthCheckOne) {
                setActiveStep(GlobalConfiguration.lengthCheckZero);
                setShowCatePopup(false);
                return;
              }
              navigate(GlobalConfiguration.lengthCheckNegativeOne);
            }}
            topNavCtaBtn2Needed={true}
            topNavCtaBtn2Props={
              checkmobile
                ? undefined
                : {
                    btnText: "Update",
                    btnType: "button",
                    enabledBgColor:
                      beneAccountsLoading ||
                      beneAccounts?.length ===
                        GlobalConfiguration.lengthCheckZero ||
                      selectedCategories?.length ===
                        GlobalConfiguration.lengthCheckZero ||
                      categoriesArray.every((item) =>
                        selectedCategories.includes(item),
                      )
                        ? "var(--text-disabled)"
                        : "var(--positive-act)",
                    enabledTextColor: "var(--text-primary)",
                    disabledTextColor: "var(--text-primary)",
                    handleFunction: () => {
                      if (
                        beneAccounts?.length ===
                          GlobalConfiguration.lengthCheckZero ||
                        selectedCategories?.length ===
                          GlobalConfiguration.lengthCheckZero ||
                        categoriesArray.every((item) =>
                          selectedCategories.includes(item),
                        )
                      ) {
                        return;
                      }
                      handleUpdateAccount(
                        beneAccountSelected?.[
                          GlobalConfiguration.lengthCheckZero
                        ],
                      );
                    },
                    isDisabled:
                      beneAccountsLoading ||
                      beneAccounts?.length ===
                        GlobalConfiguration.lengthCheckZero ||
                      selectedCategories?.length ===
                        GlobalConfiguration.lengthCheckZero ||
                      categoriesArray.every((item) =>
                        selectedCategories.includes(item),
                      ),
                    isLoading: beneAccountsLoading,
                    hoverOption: "white",
                  }
            }
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,
              isSearchDisabled: isSidebarOpen || beneAccountsLoading,
              onSearchInput: (val) => handleSearch(val),
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search reimbursement account",
              filterPlaceholder:
                "Search by account ID/ name/contact number/email ID",
              filterItems: [
                {
                  name: "Search",
                  isMulti: false,
                  value: searchUserText,
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setSearchUserText(val);
                    // setShowInnerSearchBar(false);
                  },
                  isDropdown: false,
                  isDisabled: beneAccountsLoading,
                },
              ],
              filters: [
                {
                  name: "Account status",
                  filterType: "dropdown",
                  variant: "single",
                  size: "small",
                  value: currentStatus,
                  dropdownPlaceHolder: "Select status",
                  isDisable: false,
                  options: ["approved", "pending", "rejected"],
                  statusPop: true,

                  handleChange: (e) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    if (e === "All") {
                      setCurrentStatus("all");
                    } else {
                      setCurrentStatus(e);
                    }
                  },
                },
              ],
              isFilterClearAllDisabled:
                !(currentStatus !== "all" && currentStatus !== "") ||
                beneAccountsLoading,
              isSearchClearAllDisabled:
                !searchUserText?.length || beneAccountsLoading,
              isShowFilter: true,
              active: active,
              setActive: setActive,
              loading: loadingData,
              setLoading: setLoadingData,
            }}
          />
        </div>
        <div className="beneTxnViewAll_middle_section_container mx-auto webViewRejectAll"></div>

        {beneAccounts?.length === GlobalConfiguration.lengthCheckZero ? (
          <div className="reimbursement-no-account-image-div h-full">
            {beneAccountsLoading &&
            beneAccounts?.length === GlobalConfiguration.lengthCheckZero ? (
              <div className="loader-container flex items-center justify-center">
                <Loader />
              </div>
            ) : beneAccounts?.length === GlobalConfiguration.lengthCheckZero &&
              !beneAccountsLoading ? (
              <>
                <div
                  className={
                    showInnerSearchBar
                      ? ` h-screen w-width-full bg-PopUp-BackDrop opacity-light-opacity flex flex-col items-center justify-center m-auto`
                      : "flex flex-col items-center justify-center m-auto overflow-y-scroll"
                  }
                >
                  <img
                    src={ICONS?.NO_DATA_FOUND}
                    alt="No accounts found"
                    className={`w-graphic-width-md h-graphic-rectangle-height-md
              ${showInnerSearchBar ? "opacity-light-opacity" : "opacity-base-opacity"}`}
                  />

                  <p
                    className={
                      showInnerSearchBar
                        ? "no-owneraccount-text-opacity"
                        : "text-text-primary opacity-base-opacity text-font-sm text-center py-padding-sm"
                    }
                  >
                    No accounts found with all assigned categories.
                  </p>

                  <div
                    ref={searchActionBtnRef}
                    style={{
                      opacity: showInnerSearchBar
                        ? "var(--light-opacity)"
                        : "var(--base-opacity)",
                      pointerEvents: showInnerSearchBar ? "none" : "auto",
                      display: !showInnerSearchBar ? "flex" : "none",
                    }}
                    className="oas-selectaccount"
                  >
                    <PrimaryButton
                      isDisabled={showInnerSearchBar}
                      enabledBgColor="var(--primary-act)"
                      btnText={
                        searchUserText?.length >
                          GlobalConfiguration.lengthCheckZero ||
                        (currentStatus !== "" && currentStatus !== "all")
                          ? "Clear parameters"
                          : "Home dashboard"
                      }
                      enabledTextColor="var(--text-primary)"
                      handleFunction={(e) => {
                        e.stopPropagation();
                        if (
                          searchUserText?.length >
                            GlobalConfiguration.lengthCheckZero ||
                          (currentStatus !== "" && currentStatus !== "all")
                        ) {
                          setSearchUserText("");
                          setCurrentStatus("");
                          setCurrentPage(GlobalConfiguration.lengthCheckOne);
                        } else {
                          navigate("/home");
                        }
                      }}
                      buttonRef={null}
                      hoverOption="white"
                    />
                  </div>
                </div>
              </>
            ) : null}
          </div>
        ) : (
          <div
            className={`${showInnerSearchBar && "bg-PopUp-BackDrop opacity-dark-opacity h-screen"} h-full overflow-hidden`}
          >
            <div
              className={`flex Qsmd:flex-row flex-col flex-1  ${showInnerSearchBar ? "bg-PopUp-BackDrop opacity-light-opacity overflow-hidden" : "bg-primary-bg overflow-y-hidden"}   Qsmd:w-max-content-width  Qsmd:m-auto h-full`}
            >
              <div
                //
                className={`mb-margin-xs Qsmd:mb-margin-base h-height-full flex justify-end  min-h-0  pb-pagination-height
               ${showInnerSearchBar ? "bg-PopUp-BackDrop opacity-light-opacity overflow-hidden" : "bg-primary-bg overflow-y-hidden"}
                ${ReimburseViewAllLoading ? "w-full" : "Qsmd:w-width-sm"}
                ${activeStep === GlobalConfiguration.lengthCheckZero ? "block" : "hidden"} 
                ${showInnerSearchBar && "pointer-events-none"}
                `}
              >
                {ReimburseViewAllLoading ? (
                  <div className="loader-container flex  items-center h-full Qsmd:w-width-md w-full">
                    <Loader type={"bulk_upload"} />
                  </div>
                ) : (
                  <>
                    <div
                      className={`pb-padding-sm h-full Qsmd:w-[unset] w-full   overflow-y-auto ${showInnerSearchBar && "pointer-events-none"}`}
                    >
                      <div className="standard-card-alignment_reibursement gap-x-gap-sm">
                        {beneAccounts?.map((val, index) => {
                          if (
                            val?.approval_status !== "blocked" &&
                            val?.approval_status !== "archived"
                          ) {
                            return (
                              <div
                                key={val?.id}
                                className="flex justify-between  gap-gap-md pt-padding-md relative"
                              >
                                <div className="acc-data-sep-line mt-[calc(-1*var(--margin-md))]">
                                  <div
                                    className="acc-data-div-sep-line_reibursement"
                                    style={{
                                      height:
                                        index ===
                                        GlobalConfiguration.lengthCheckZero
                                          ? "var(--mobile-navbar-height)"
                                          : "var(--card-height)",
                                      marginTop:
                                        index ===
                                        GlobalConfiguration.lengthCheckZero
                                          ? ""
                                          : "var(--reimbursment-cat-zeroth-item)",
                                    }}
                                  ></div>
                                  <div
                                    className="acc-data-div-sep-line-dot_reibursement absolute"
                                    style={{
                                      width: beneAccountSelected.includes(
                                        val?.id,
                                      )
                                        ? "var(--icon-md)"
                                        : "var(--icon-sm)",
                                      height: beneAccountSelected.includes(
                                        val?.id,
                                      )
                                        ? "var(--icon-sm)"
                                        : "var(--icon-sm)",
                                      borderRadius:
                                        beneAccountSelected.includes(val?.id)
                                          ? "var(--margin-button-m)"
                                          : "var(--width-md)",
                                    }}
                                  >
                                    <div
                                      className="acc-data-div-sep-line-inner-dot_reibursement"
                                      style={{
                                        width: beneAccountSelected.includes(
                                          val?.id,
                                        )
                                          ? "var(--icon-sm)"
                                          : "var(--margin-button-m)",
                                        height: beneAccountSelected.includes(
                                          val?.id,
                                        )
                                          ? "var(--margin-button-m)"
                                          : "var(--margin-button-m)",
                                        borderRadius:
                                          beneAccountSelected.includes(val?.id)
                                            ? "var(--margin-button-m)"
                                            : "var(--width-md)",
                                      }}
                                    ></div>
                                  </div>
                                </div>

                                <CardContainer
                                  key={index}
                                  context={val}
                                  index={index}
                                  cardBgColor="primary-nav"
                                  isSelected={
                                    Array.isArray(beneAccountSelected) &&
                                    beneAccountSelected.includes(val.id)
                                  }
                                  isDisabled={showInnerSearchBar ? true : false}
                                  onClickHandler={() => {
                                    if (!showInnerSearchBar) {
                                      setShowCatePopup(!showCatePopup);
                                      handleClickAccountCard(val?.id);
                                    }
                                  }}
                                >
                                  <card-body>
                                    <TextWithIcon
                                      type="text"
                                      fontWeight="normal"
                                      subText="Account name"
                                      text={val.name
                                        ?.toLowerCase()
                                        .split(" ")
                                        .map(
                                          (word) =>
                                            word
                                              .charAt(
                                                GlobalConfiguration.lengthCheckZero,
                                              )
                                              .toUpperCase() +
                                            word.slice(
                                              GlobalConfiguration.lengthCheckOne,
                                            ),
                                        )
                                        .join(" ")}
                                      textColor={"var(--text-primary)"}
                                      // iconComponentArray={
                                      //   Array.isArray(beneAccountSelected) &&
                                      //   beneAccountSelected.includes(val.id)
                                      //     ? [
                                      //         {
                                      //           icon: ICONS?.SELECTED_WITH_GREEN_CIRCLE,
                                      //           isDisabled: false,
                                      //         },
                                      //       ]
                                      //     : []
                                      // }
                                    />

                                    <div className="flex gap-x-gap-sm justify-between items-center">
                                      <div className="flex flex-1 truncate flex-col gap-y-gap-xs">
                                        <p
                                          className={`text-font-sm text-text-primary flex-1 truncate font-normal pl-padding-sm`}
                                        >
                                          <TickerAnimation
                                            text={formatAccountNumber(
                                              val.bank_acc_no,
                                            )}
                                          />
                                        </p>
                                        <div className="w-full relative flex pl-padding-sm justify-between items-center ">
                                          <p
                                            className={`text-font-xs text-text-secondary flex-1 truncate font-normal transform-none`}
                                          >
                                            Account number
                                          </p>
                                        </div>
                                      </div>
                                      <div className="bg-text-primary flex items-center gap-x-gap-sm rounded-l-border-radius-md py-padding-xs px-padding-sm">
                                        <div className="w-banklogo-width-sm h-icon-xs flex-shrink-0">
                                          <IfscCodeMapper
                                            ifscCode={val?.ifsc_code}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </card-body>
                                  <card-hover>
                                    <TextWithIcon
                                      text={val?.approval_status}
                                      subText={"Account status"}
                                      textCase={"capitalize"}
                                      fontWeight={"semibold"}
                                      textColor={getStatusColor(
                                        val?.approval_status,
                                      )}
                                    />
                                    <TextWithIcon
                                      text={
                                        val?.labels?.join(", ") ||
                                        "No labels assigned"
                                      }
                                      iconComponentArray={[
                                        {
                                          icon: ICONS.LABEL,
                                        },
                                      ]}
                                      fontWeight={"normal"}
                                      textColor={"var(--text-primary)"}
                                    />
                                  </card-hover>
                                </CardContainer>
                              </div>
                            );
                          } else {
                            return null;
                          }
                        })}
                      </div>
                    </div>
                  </>
                )}
              </div>
              {!ReimburseViewAllLoading && (
                <div
                  className={`flex flex-1 justify-start 
                no-scrollbar
                w-full Qsmd:w-width-lg
                ${activeStep === GlobalConfiguration.lengthCheckOne ? "block" : "hidden"}
                Qsmd:flex
                ${isSidebarOpen || showInnerSearchBar ? "overflow-hidden pointer-events-none bg-PopUp-BackDrop opacity-light-opacity" : "overflow-y-auto   bg-primary-bg"}
              `}
                >
                  <div className="ml-margin-sm p-padding-md Qsmd:w-width-lg w-full">
                    <CategoriesEdit
                      sortedCategories={sortedCategories}
                      selectedCategories={selectedCategories}
                      handleCategorySelect={handleCategorySelect}
                      Title="Assign Categories"
                      SubTitle="Restrict the number of categories, as selecting all is not recommended."
                      TitleFontcolor="text-primary"
                      TextSize="font-md"
                      SubTitleFontcolor="text-secondary"
                      SubTitleTextSize="font-xs"
                      TitleFontWeight="semibold"
                      SubTitleFontWeight="normal"
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {!beneAccountsLoading &&
        beneAccounts?.length > GlobalConfiguration?.lengthCheckZero && (
          <div className="Qsmd:h-pagination-height flex flex-shrink-0 bg-primary-bg"></div>
        )}
    </div>
  );
};

export default ReimbursementUnassignCategories;
